import { Select } from 'components/Select/Select'
import { translate } from 'i18n/i18n'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect } from 'react'
import { colors } from 'settings/colors'
import { checkAuthorization } from 'utils/checkAuthorization'
import { ErrorTextWrapper } from '../../components/ErrorTextWrapper'

export const WEEKLY_UPDATE_REPORT_TYPE = 'Weekly Update'

export const WEEKLY_TRAP_CATCHES_REPORT_TYPE = 'Weekly Trap Catches'

export const WEEKLY_TRAP_ISSUES_REPORT_TYPE = 'Weekly Trap Issues'

export type TReportType =
  | typeof WEEKLY_UPDATE_REPORT_TYPE
  | typeof WEEKLY_TRAP_CATCHES_REPORT_TYPE
  | typeof WEEKLY_TRAP_ISSUES_REPORT_TYPE
  | ''

export const ReportType = ({
  reportId,
  setReportType,
  reportType,
  triedToSubmit,
  setTypeIsValid,
}: {
  reportId: string | null
  setReportType: Dispatch<SetStateAction<TReportType>>
  reportType: TReportType
  triedToSubmit: boolean
  setTypeIsValid: Dispatch<SetStateAction<boolean>>
}) => {
  let helpText = ''
  let validateStatusError = false

  if (!reportType && triedToSubmit) {
    helpText = translate.phrases.banyanApp('Must select a report type')

    validateStatusError = true
  }

  useEffect(() => {
    setTypeIsValid(!validateStatusError)
  }, [reportType])

  const hasViewTrapIssuesPermission = checkAuthorization({
    permission: 'VIEW_SSC_NODE_ISSUE_TRAPS',
    entity: 'FOR_ANY_PROPERTY',
  })

  const reportTypeOptions = [
    { value: WEEKLY_UPDATE_REPORT_TYPE, label: translate.phrases.banyanApp('Weekly Update') },
    {
      value: WEEKLY_TRAP_CATCHES_REPORT_TYPE,
      label: translate.phrases.banyanApp('Weekly Trap Catches'),
    },
    ...(hasViewTrapIssuesPermission
      ? [
          {
            value: WEEKLY_TRAP_ISSUES_REPORT_TYPE,
            label: translate.phrases.banyanApp('Weekly Trap Issues'),
          },
        ]
      : []),
  ]

  return (
    <div css={{ paddingBottom: '25px', borderBottom: `1px solid ${colors.grey200}` }}>
      <h4>{translate.phrases.banyanApp('Type')}</h4>
      <Select
        data={reportTypeOptions}
        placeholder={translate.phrases.banyanApp('Choose a report type')}
        value={reportType}
        handleOnChange={(newValue) => {
          if (
            newValue === WEEKLY_UPDATE_REPORT_TYPE ||
            newValue === WEEKLY_TRAP_CATCHES_REPORT_TYPE ||
            newValue === WEEKLY_TRAP_ISSUES_REPORT_TYPE
          ) {
            setReportType(newValue ?? '')
          }
        }}
        disabled={reportId ? true : false}
      />
      {validateStatusError && <ErrorTextWrapper>{helpText}</ErrorTextWrapper>}
    </div>
  )
}
